
import React, { Component } from 'react';

import NoDisplayedLoading from '../NoDisplayedLoading/NodisplayedLoading';

import TaggingController from '../../controllers/Tagging';

import './TaggingSidebar.css';

const SideBarStates = {
  Loading: 'Loading',
  Loaded: 'Loaded',
  Error: 'Error',
};

class TaggingSidebar extends Component {

  constructor( props) {
    super( props);
    const { taggingConfiguration = {} } = props;
    const { taggings, chapters, setOnTime } = taggingConfiguration;
    
    this.state = {
      sidebarState: SideBarStates.Loading,
      currentTime: 0,
      currentTagging: undefined,
      taggings,
      chapters,
    }

    this.onTime = this.onTime.bind( this);
    this.isActiveElement = this.isActiveElement.bind( this);
    this.renderTaggingableChapter = this.renderTaggingableChapter.bind( this);
    this.renderTaggingableText = this.renderTaggingableText.bind( this);

    if( setOnTime) setOnTime( this.onTime);
  }

  onTime({ position } = {}) {
    this.setState({ currentTime: position });
  }

  isActiveElement( element) {
    const { currentTime } = this.state;
    return (currentTime >= element.begin || isNaN( element.begin)) && (currentTime < element.end || isNaN( element.end));
  }

  renderTaggingableChapter( key, element) {
    const { player, taggingConfiguration } = this.props;
    const isActiveElement = this.isActiveElement( element);

    const className = isActiveElement ? 'transcript-title-active' : 'transcript-title';
    return (
      <h4 key={key} onClick={ () => player.seek( element.begin | 0)}
        className={ className + ' ' + taggingConfiguration.taggingStyle}
        dangerouslySetInnerHTML={{ __html: element.text}}
      ></h4>
    );
  }

  renderTaggingableText( key, element) {
    const { player, taggingConfiguration } = this.props;
    const isActiveElement = this.isActiveElement( element);

    const className = isActiveElement ? 'transcript-text-active' : 'transcript-text';
    return (
      <span key={key} onClick={ () => player.seek( element.begin | 0)}
        className={ className + ' ' + taggingConfiguration.taggingStyle}
        dangerouslySetInnerHTML={{ __html: element.text}}
      ></span>
    );
  }

  renderTabContent( tagging, chapters) {
    const rendered = [];

    const renderChapter = chapter => {
      rendered.push( this.renderTaggingableChapter( `chapter ${chapter}`, chapters[chapter]));
    }
    const renderText = tag => {
      rendered.push( this.renderTaggingableText( `text ${tag}`, tagging[tag]));
    }

    let tag = 0, chapter = 0;
    while( tag < tagging.length && chapter < chapters.length) {
      if( chapters[chapter].begin <= tagging[tag].begin || isNaN( chapters[chapter].begin) ) {
        renderChapter( chapter);
        chapter += 1;
      } else {
        renderText( tag);
        tag += 1;
      }
    }
    while( chapter < chapters.length) {
      renderChapter( chapter);
      chapter += 1;
    }
    while( tag < tagging.length) {
      renderText( tag);
      tag += 1;
    }

    return rendered;
  }

  render() {
    if( !this.props.player) return <div debug='Waiting for player'/>;
    const { taggingConfiguration } = this.props;
    const { taggings, chapters, currentTagging } = this.state;
    const { taggingStyle } = taggingConfiguration;

    const width = (1 - taggingConfiguration.widthFactor) * window.innerWidth;
    const height = window.innerHeight;

    switch( this.state.sidebarState) {
      case SideBarStates.Loading:
        return <NoDisplayedLoading />;
      case SideBarStates.Loaded:
        return (
          <div className={`sidebar ${taggingStyle}`} style={{ width, height }}>
            <div className='transcript'>
              <div className='tab'>
                { Object.keys( taggings).map( (label, i) => {
                  const className = currentTagging === label ? 'tablinks-active' : 'tablinks';
                  return <button key={i} className={className} onClick={ () => this.setState({ currentTagging: label })}> {label}</button>;
                }) }
              </div>
              <div className='tabcontent'>
                { this.renderTabContent( taggings[ currentTagging ], chapters) }
              </div>
            </div>
          </div>
        );
      case SideBarStates.Error:
        return <div debug='Error'/>;
      default:
        return <div debug='Unrecognize Sidebar State'/>;
    }
  }

  async componentDidMount() {
    // console.log( 'components::TaggingSidebar::componentDidMount');    // DEBUG
    const { taggingConfiguration } = this.props;
    const { defaultLanguage } = taggingConfiguration;

    const { taggings, chapters } = await TaggingController.loadTranscription( taggingConfiguration);
    const labels = Object.keys( taggings);
    // console.log( 'components::TaggingSidebar::componentDidMount - taggings: ', taggings, ', chapters: ', chapters, ', labels: ', labels);    // DEBUG

    if( labels.length > 0) {
      const currentTagging = labels.reduce( (previous, label) => {
        return label === defaultLanguage ? label : previous;
      }, labels[0]);
  
      // console.log( 'components::TaggingSidebar::componentDidMount - currentTagging: ', currentTagging, ', taggings: ', taggings, ', chapters: ', chapters);    // DEBUG
      this.setState({ sidebarState: SideBarStates.Loaded, currentTagging, taggings, chapters });
    } else {
      this.setState({ sidebarState: SideBarStates.Error });
    }
  }

}

export default TaggingSidebar;
